import React from 'react';
import Header from './Header';
import Navbar from './Navbar';
import DealProducts from './DealProducts';
// import BannerSection from './components/BannerSection';
import DealProductcard from './DealProductcard';
import PromoBanner from './PromoBanner';
import BlogSection from './BlogSection';
import NewsletterSection from './NewsletterSection';
import OriginalBrands from './OriginalBrands';
import LatestTestimonials from './LatestTestimonials';
import ShilajitBanner from './ShilajitBanner';
import Footers from './Footers';
import BrandPromoSection from './BrandPromoSection';
import HeroBanner from './HeroBanner';

function Home() {
  return (
    <div>
      <Header />
      <Navbar />
      <HeroBanner />
      <BrandPromoSection />
      <DealProducts />
      <PromoBanner />
      <DealProductcard />
      <OriginalBrands />
      <ShilajitBanner />
      {/* <BannerSection /> */}
      <BlogSection />
      <LatestTestimonials />
      <NewsletterSection />
      <Footers />
    </div>
  );
};



export default Home;


// https://www.purehimalayanshilajit.com/about/





